import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import OrderForm from './OrderForm';
import SafeIcon from '../common/SafeIcon';

/**
 * CustomerPortal
 * This acts as the "Shell" for the standalone customer-facing application.
 * It removes all admin navigation and provides a clean, professional order environment.
 */
const CustomerPortal = () => {
  const { slug } = useParams();
  const { settings, t } = useAppContext();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Standalone Header for Customers */}
      <header className="bg-white border-b border-gray-200 py-4 px-6 sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-amber-100 p-2 rounded-lg">
              <SafeIcon name="Briefcase" className="w-6 h-6 text-amber-600" />
            </div>
            <div>
              <h1 className="font-bold text-lg text-gray-900 leading-none">
                {settings.company.name}
              </h1>
              <p className="text-[10px] text-gray-400 uppercase font-black tracking-widest mt-1">
                Order Portal
              </p>
            </div>
          </div>
          
          <div className="hidden md:flex items-center gap-4 text-xs text-gray-500">
            <span className="flex items-center gap-1">
              <SafeIcon name="Phone" className="w-3 h-3" />
              {settings.company.phone}
            </span>
          </div>
        </div>
      </header>

      {/* Main Order Content */}
      <main className="flex-1 py-8">
        <OrderForm />
      </main>

      {/* Simplified Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 px-6 mt-auto">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} {settings.company.name}. {t('settings.footerText')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CustomerPortal;